import { Luscinia, luscinia } from "./luscinia";

luscinia.initSummernote = function (form, culture) {
    //Summernote plugin
    (function (factory) {
        /* global define */
        //@ts-ignore
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            //@ts-ignore
            define(['jquery'], factory);
            //@ts-ignore
        } else if (typeof module === 'object' && module.exports) {
            // Node/CommonJS
            //module.exports = factory(require('jquery'));
        } else {
            // Browser globals
            //@ts-ignore
            factory(window.jQuery);
        }
    });

    function initSummernoteButtongroup(editor, columnElements = "") {
        var insertValuesDropdown = function (context) {
            var ui = ($ as any).summernote.ui;

            var dropDownBtnGroup = ui.buttonGroup([
                ui.button({
                    className: 'dropdown-toggle',
                    contents: 'Insert fields <span class="caret"></span>',
                    tooltip: "Variables",
                    data: {
                        toggle: 'dropdown'
                    }
                }),
                ui.dropdown({
                    className: 'dropdown-style',
                    contents: columnElements,
                    callback: function ($dropdown) {
                        $dropdown.find('li').each(function () {
                            $(this).click(function () {
                                context.invoke("editor.insertText", "{" + $(this).children("a").first().text() + "}");
                            });
                        });
                    }
                })
            ]);

            return dropDownBtnGroup.render();
        };

        ($(editor) as any).summernote({
            height: 250,
            lang: culture,
            dialogsInBody: false,
            callbacks: {
                onChange: function (contents, $editable) {
                    luscinia.SummerNoteCleanHtml(this, "b", contents);
                    luscinia.SummerNoteCleanHtml(this, "i", contents);
                }
            },
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['height', ['height']],
                ['table', ['table']],
                ['insert', ['hr', 'link', 'picture', 'video', 'filebrowser']],
                ['view', ['fullscreen', 'codeview']],
                ['help', ['help']],
                ['extraValues', ['insertValues']]
            ],
            buttons: {
                insertValues: insertValuesDropdown
            }
        });
        setTimeout(function () {
            ($(editor) as any).summernote('focus');
        }, 0);
    }

    // Init summernote html editor
    var $editor = $(form).find(".luscinia-htmleditor");

    ($editor as any).each(function (index, item) {
        var objectId = $(form).find("[Name=" + $(item).data("luscinia-dropdown-objectid") + "]").val();
        var dropdownUrl = $(item).data("luscinia-dropdown-get-url");
        if (dropdownUrl !== null && dropdownUrl !== undefined) {
            var listElementsString = "";
            $.get($(item).data("luscinia-dropdown-get-url") + "/" + objectId, function (response) {
                $(response).each(function (responseIndex, responseItem) {
                    listElementsString += "<li><a href='#'>" + responseItem + "</a></li>";
                });
            }).done(function () {
                initSummernoteButtongroup(item, listElementsString);
            });
        }
        else {
            initSummernoteButtongroup(item);
        }
    });
};

luscinia.SummerNoteCleanHtml = function (editor, type, value) {
    if (value.indexOf("<" + type + ">") >= 0) {
        var marca: RegExp;
        var replaceIniTag: string;
        var replaceEndTag: string;
        if (type === "b") {
            marca = /<b(?:.*?)>(?:.*?)<\/b>/g;
            replaceIniTag = "<strong>";
            replaceEndTag = "</strong>";
        } else {
            marca = /<i(?:.*?)>(?:.*?)<\/i>/g;
            replaceIniTag = "<em>";
            replaceEndTag = "</em>";
        }
        var matches = value.match(marca),
            len = matches.length,
            i;
        for (i = 0; i < len; i++) {
            var str = $(matches[i]).text();
            str = replaceIniTag + str + replaceEndTag;
            value = value.replace(matches[i], str);
        }
        ($(editor) as any).summernote("code", value); //Replace the editor content
    }
};